import axios from "axios";

export default {
  namespaced: true,
  state: {
    fabills: [],
    images: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    fabillsMessage: ''
  },
  mutations: {
    CLEAR_FABILLS(state) {
      state.fabills = [];
    },
    FINDING_FABILLS(state, payload) {
      state.isReceiving = true;
      state.query = Object.assign({}, payload);
    },
    RECEIVED_FABILLS(state, payload) {
      state.fabills = payload;
      state.isReceiving = false;
    },
    RECEIVED_FABILL(state, payload) {
      let find = state.fabills.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { fabills: [payload, ...state.fabills] });
      }
      else {
        let index = state.fabills.findIndex(i => i._id === payload._id);
        state.fabills.splice(index, 1, payload);
      }
    },
    RECEIVING_FABILLS(state) {
      state.isReceiving = true;
    },
    RECEIVING_FABILL(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },


    UPDATED_FABILL(state, payload) {
      let index = state.fabills.findIndex(fabill => fabill._id === payload._id);
      state = Object.assign(state, {
        fabills: state.fabills.map((fabill, i) => {
          if (i === index) {
            return Object.assign({}, fabill, payload);
          }
          return fabill;
        }),
        isUpdating: false,
        fabillsMessage: 'FABills has been updating!',
      })
    },
    UPDATING_FABILL(state) {
      state.isUpdating = true;
    },
    DELETED_FABILL(state, payload) {
      let indexToDelete = state.fabills.findIndex(fabill => fabill._id === payload._id);
      let fabills = [...state.fabills];
      fabills.splice(indexToDelete, 1);
      state = Object.assign(state, {
        fabills: [...fabills],
        isDeleting: false,
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_FABILL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteFABillRequest({dispatch}, payload) {
      dispatch("deletingFABill", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/fabill/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteFABill", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteFATransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/fatransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async deleteFADepreciationRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/fadepreciation/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertFABillRequest({dispatch}, payload) {
      try {
        dispatch("receivingFABills");
        var token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/fabill';
        let data = payload;
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log('here2', token);
        console.log('here2', data);
        let response = await axios({method: "post", url: url, headers: headers, data: data});
        await dispatch("receiveFABill", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }

    },
    async insertFATransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/fatransaction/" + payload.fabillid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async insertFADepreciationRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/fadepreciation/" + payload.fabillid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        console.log(response.data)
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getFABillsRequest({dispatch}) {
      dispatch("receivingFABills");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/fabills';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log('fabills', response.data)
        dispatch("receiveFABills", response.data);
      })
    },
    async getFABillRequest({dispatch}, id) {
      dispatch("receivingFABill");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/fabill/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        dispatch("receiveFABill", response.data);
      })
    },
    async findFABillsRequest({dispatch}, payload) {
      try{
        dispatch("findingFABills", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/fabills';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveFABills", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateFABillRequest({dispatch}, payload) {
      dispatch("updatingFABill");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/fabill/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateFABill", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateFATransaction({dispatch}, payload) {
      try{
        dispatch("receivingFABill");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/fatransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingFABill", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateFADepreciation({dispatch}, payload) {
      try{
        dispatch("receivingFABill");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/fadepreciation/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingFABill", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    clearFABills({commit}) {
      commit("CLEAR_FABILLS")
    },
    findingFABills({commit}, payload) {
      commit("FINDING_FABILLS", payload)
    },
    receiveFABills({commit}, payload) {
      commit("RECEIVED_FABILLS", payload)
    },
    receiveFABill({commit}, payload) {
      commit("RECEIVED_FABILL", payload)
    },
    receivingFABills({commit}) {
      commit("RECEIVING_FABILLS")
    },
    receivingFABill({commit}) {
      commit("RECEIVING_FABILL")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    updateFABill({commit}, payload) {
      commit("UPDATED_FABILL", payload)
    },
    updatingFABill({commit}) {
      commit("UPDATING_FABILL")
    },
    deleteFABill({commit}, payload) {
      commit("DELETED_FABILL", payload)
    },
    deletingFABill({commit}, payload) {
      commit("DELETING_FABILL", payload)
    }
  },
};
